export default __webpack_public_path__ + "static/media/rabbit_type_9_2.1b21d95f.svg";